import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Paper from '@material-ui/core/Paper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/fontawesome-free-solid'

import { CircularProgress } from '../../../common'
import MyBookingsHandler from '../../../containers/MyBookingsHandler'
import MenuHeader from '../../../containers/MenuHeader'
import OfflineModeHeader from '../../../containers/OfflineModeHeader'

import * as Strings from './strings'
import * as Styles from './styles'
import * as Functions from '../../../../helpers/Functions'
import * as Constants from '../../../../helpers/Constants'
import * as userActions from '../../../../actions/User'
import * as bookingSystemActions from '../../../../actions/BookingSystems'
import * as offlineModeActions from '../../../../actions/OfflineMode'
import * as bookingSystemBookingActions from '../../../../actions/BookingSystemBookings'

class MyBookings extends Component {
  state = {
    hover: null
  }

  componentDidMount() {
    const { history, user, offlineMode, data } = this.props

    if (offlineMode) {
      if (!user.offlineModeSignedIn) {
        this.props.setOfflineSetup()
      }
    } else if (!user.fetched) {
      history.push('/')
    } else if (!data.bookingSystemsFetched) {
      this.props.tryGetBookingSystems(user.token)
    }
  }

  idIsPresentAndExists() {
    const { match, data } = this.props

    if (!match.params.id || !data.bookingSystemsFetched) {
      return false
    }

    let isPresent = false

    Object.keys(data.bookingSystems).forEach(key => {
      if (key.toString() === match.params.id.toString()) {
        isPresent = true
      }
    })

    return isPresent
  }

  getMyBookings() {
    const { data, user, match, bookingSystemBookings } = this.props
    const system = data.bookingSystems[match.params.id]
    const bookings = []

    system.times.forEach(time => {
      time.bookings.forEach(booking => {
        if (booking.apartmentId === data.apartment.id) {
          bookings.push({
            id: booking.id,
            date: Functions.parseDate(new Date(booking.date)),
            time: time.start + '-' + time.end,
            title: system.name,
            isDeleting:
              bookingSystemBookings.isDeleting.indexOf(booking.id) !== -1,
            deleteBooking: () =>
              this.props.tryDeleteBookingForBookingSystem(
                user.token,
                system.id,
                booking.id,
                user.offlineModeSignedIn
              )
          })
        }
      })
    })

    return bookings
  }

  renderBookingSystems() {
    const { hover } = this.state
    const { data, config, history, offlineMode, user } = this.props
    const systems = []

    Object.keys(data.bookingSystems).forEach(key => {
      const system = data.bookingSystems[key]

      systems.push(
        <Item
          key={system.id}
          header={system.name}
          onMouseEnter={() => this.setState({ hover: system.id })}
          onMouseLeave={() => this.setState({ hover: null })}
          hover={hover === system.id}
          onClick={
            offlineMode
              ? () => history.push('/testmode/mybookings/' + system.id)
              : () => history.push('/mybookings/' + system.id)
          }
        />
      )
    })

    if (systems.length === 0 && user.isAdmin) {
      return <p>{Strings.default.NO_BOOKING_SYSTEMS_ADMIN[config.language]}</p>
    }

    if (systems.length === 0) {
      return <p>{Strings.default.NO_BOOKING_SYSTEMS[config.language]}</p>
    }

    return systems
  }

  renderContent() {
    const { data, user, offlineMode, match, history, config } = this.props

    if (!user.fetched && !offlineMode) {
      history.push('/')
    }

    if (!user.fetched || !data.bookingSystemsFetched) {
      return <CircularProgress />
    }

    if (this.idIsPresentAndExists()) {
      const system = data.bookingSystems[match.params.id]

      return (
        <div style={Styles.default.innerContainer}>
          <MyBookingsHandler
            items={this.getMyBookings()}
            title={
              Strings.default.MY[config.language] +
              ' ' +
              system.name.toLowerCase() +
              '-' +
              Strings.default.BOOKINGS[config.language]
            }
          />
        </div>
      )
    }

    return (
      <div
        style={{
          ...Styles.default.container,
          paddingTop: offlineMode ? 150 : 100
        }}
      >
        {this.renderBookingSystems()}
      </div>
    )
  }

  render() {
    const { config, data, history, match } = this.props
    const system = data.bookingSystems[match.params.id]
    const header = this.idIsPresentAndExists()
      ? Strings.default.MY[config.language] +
        ' ' +
        system.name.toLowerCase() +
        '-' +
        Strings.default.BOOKINGS[config.language]
      : Strings.default.SELECT_BOOKING_SYSTEM[config.language]

    return (
      <MenuHeader
        history={history}
        header={header}
        selected={Constants.MY_BOOKING_SYSTEM_BOOKINGS_FOCUSED}
      >
        <OfflineModeHeader history={history} />
        {this.renderContent()}
      </MenuHeader>
    )
  }
}

const Item = ({ header, onMouseEnter, onMouseLeave, hover, onClick }) => {
  return (
    <Paper
      style={Styles.default.paperContainer}
      className={'hover'}
      onMouseEnter={() => onMouseEnter()}
      onMouseLeave={() => onMouseLeave()}
      onClick={() => onClick()}
    >
      <div style={Styles.default.innerPaperContainer}>
        <p style={Styles.default.text}>{header}</p>
      </div>
      <FontAwesomeIcon
        icon={faChevronRight}
        style={{
          ...Styles.default.icon,
          color: hover
            ? Constants.WHITE_LABEL.colors.primaryHover
            : Constants.WHITE_LABEL.colors.primary
        }}
      />
    </Paper>
  )
}

function mapStateToProps({ user, config, data, bookingSystemBookings }) {
  return { user, data, config, bookingSystemBookings }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...userActions,
      ...bookingSystemActions,
      ...offlineModeActions,
      ...bookingSystemBookingActions
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyBookings)



// WEBPACK FOOTER //
// ./src/components/pages/bookingSystems/MyBookings/index.js